import { Controller } from '@hotwired/stimulus';

export default class ClipboardController extends Controller {
  static targets = [
    'source',
    'button'
  ];

  connect() {
    this.buttonTargets.forEach(function(button) {
      $(button).tooltip();
    });
  }

  copy(event) {
    event.preventDefault();
    var button = event.currentTarget;
    var index = this.buttonTargets.indexOf(button);
    var sourceElement = this.sourceTargets[index];

    if (sourceElement) {
      var textToCopy = sourceElement.textContent.trim();

      navigator.clipboard.writeText(textToCopy).then(function() {
        $(button).tooltip('show');

        setTimeout(function() {
          $(button).tooltip('hide');
        }, 2000);
      }).catch(function(err) {
        console.error('Failed to copy:', err);
      });
    }
  }
}
